import fetch from 'isomorphic-fetch';

const ENDPOINT_URL = process.env.VUE_APP_EDITAR_PLANILLA;
async function editarPlanilla(planilla) {
  const bodyParams = {
    planilla,
    token: localStorage.getItem('token'),
  };

  let body = JSON.stringify(bodyParams);

  return await fetch(ENDPOINT_URL, {
    method: 'put',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  }).then((item) => item.json());
}
export { editarPlanilla };
